<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import GuestLayout from '@/Layouts/GuestLayout.vue';

defineProps({
  canResetPassword: {
    type: Boolean,
  },
  status: {
    type: String,
  },
});

const form = useForm({
  email: '',
  password: '',
  remember: false,
});

const submit = () => {
  form.post(route('login'), {
    onFinish: () => form.reset('password'),
  });
};
</script>

<template>
  <GuestLayout>
    <Head title="Connexion"/>

    <div v-if="status" class="mt-6 text-sm font-medium text-green-600">
      {{ status }}
    </div>

    <form @submit.prevent="submit">
      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="email"
              type="email"
              fluid
              autofocus
              autocomplete="username"
              required
              v-model="form.email"
              :invalid="!!form.errors.email"
          />

          <label for="email">Adresse e-mail</label>
        </FloatLabel>

        <Message v-if="!!form.errors.email" severity="error">
          {{ form.errors.email }}
        </Message>
      </div>

      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="password"
              type="password"
              fluid
              autocomplete="current-password"
              required
              v-model="form.password"
              :invalid="!!form.errors.password"
          />

          <label for="email">Mot de passe</label>
        </FloatLabel>

        <Message v-if="!!form.errors.password" severity="error">
          {{ form.errors.password }}
        </Message>
      </div>

      <div class="mt-6 block">
        <label for="remember" class="flex items-center">
          <Checkbox
            v-model="form.remember"
            inputId="remember"
            name="remember"
            binary
          />

          <span class="ms-2 text-sm text-gray-600">Se souvenir de moi</span>
        </label>
      </div>

      <div class="my-6 flex items-center justify-end">
        <Link
            v-if="canResetPassword"
            :href="route('password.request')"
            class="rounded-md text-sm text-gray-600 underline hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          Mot de passe oublié ?
        </Link>

        <Button type="submit" class="ml-4" :disabled="form.processing">
          Se connecter
        </Button>
      </div>
    </form>
  </GuestLayout>
</template>
